import * as _ from 'underscore'

let dict = [
    {
        name: `เงินฝากและตลาดเงิน`,
        desc: `เงินฝาก คือ  เงินที่ฝากไว้กับธนาคารเพื่อรับผลตอบแทนในรูปดอกเบี้ย หรือเพื่อทำธุรกรรมต่าง ๆ<br><br> 
บัญชีเงินฝากแบ่งออกเป็น 3 ประเภทใหญ่ คือ เงินฝากออมทรัพย์ เงินฝากประจำ และเงินฝากกระแสรายวัน ซึ่งสถาบันการเงินแต่ละแห่งอาจจะมีชื่อเรียกที่แตกต่างกัน <br><br>
ตลาดเงิน คือ การลงทุนในตราสารระยะสั้นไม่เกิน 1 ปี เช่น เงินฝาก บัตรเงินฝาก ตั๋วสัญญาใช้เงิน ตั๋วแลกเงิน เป็นต้น
`,
        return: `~1.25`
    },
    {
        name: `ตราสารหนี้และกองทุนรวมตราสารหนี้`,
        desc: `ตราสารหนี้ คือสัญญากู้ยืมเงิน โดยผู้ออกตราสาร (ลูกหนี้) ตกลงจะจ่ายดอกเบี้ยเป็นงวด ๆ และคืนเงินต้นให้กับผู้ถือตราสารหรือผู้ลงทุน (เจ้าหนี้) ตามระยะเวลาที่กำหนดไว้
ชื่อเรียกของตราสารหนี้ แตกต่างกันไปขึ้นอยู่กับใครเป็นผู้ออกตราสาร เช่น เงินฝากธนาคาร คือตราสารหนี้รูปแบบหนึ่ง ธนาคารเป็นผู้ออกตราสาร ชื่อเรียกตราสารคือ “บัญชีเงินฝาก” ถ้ารัฐบาลออกตราสาร เรียกว่า “พันธบัตรรัฐบาล” และถ้าเอกชนออกตราสาร เรียกว่า “หุ้นกู้” <br><br>
กองทุนรวมตราสารหนี้<br>
กองทุนรวมที่มีนโยบายลงทุนในตราสารหนี้ มีความเสี่ยงปานกลางค่อนข้างต่ำ ขึ้นอยู่กับประเภทตราสารหนี้ที่กองนั้นลงไป เช่น กองทุนที่ลงทุนในพันธบัตรรัฐบาลอาจจะมีความเสี่ยงในระดับต่ำกว่ากองทุนที่ลงในหุ้นกู้เอกชน
เน้นถือไปเรื่อย ๆ ราคาไม่หวือหวา

`,
        return: `~2.50`
    },
    {
        name: `หุ้นและกองทุนรวมไทย`,
        desc: `หุ้น คือตราสารที่ออกให้แก่ผู้ที่ลงทุนเพื่อแสดงความเป็นเจ้าของ ตามสัดส่วนจำนวนหุ้นที่ถืออยู่
<br><br> กองทุนรวมหุ้น เป็นกองทุนรวมความเสี่ยงสูงประเภทหนึ่ง ซึ่งจะลงทุนในตราสารทุนประเภทต่างๆ ซึ่งได้แก่ หุ้นสามัญ หุ้นบุริมสิทธิ ใบสําคัญแสดงสิทธิในการซื้อหลักทรัพย์ (Warrant) รวมถึงหน่วยลงทุนของกองทุนรวมอื่นๆ ซึ่งเป็นไปตามนโยบายของกองทุนนั้น ๆ
`,
        return: `~6.5`
    },
    {
        name: `กองทุนผสม`,
        desc: `กองทุนผสม คือ กองทุนที่มีสัดส่วนการลงทุนในหุ้นและตราสารหนี้ที่แตกต่างกัน เพื่อผลตอบแทนที่ดีขึ้น และเป็นการกระจายความเสี่ยงไปในเวลาเดียวกัน`,
        return: `~4.0`
    },
    {
        name: `หุ้นและกองทุนรวมหุ้นต่างประเทศ`,
        desc: `แบบประกันที่ออกแบบมาให้ผู้ถือกรมธรรม์ออมเงิน พร้อมกับมีความคุ้มครองแถมมาด้วย ซึ่งการออมเงินจะจ่ายเงินคืนตามระยะเวลาที่กำหนดเอาไว้ในสัญญา`,
        return: `~9.0`
    },
    {
        name: `ทองคำ`,
        desc: `การลงทุนทองคำถือเป็นการลงทุนในรูปแบบหนึ่ง มีหลักการเพียงแค่ซื้อทองคำมาและขาย เพื่อทำกำไรจาก   ‘ส่วนต่าง’  ของราคาทองคำที่เพิ่มสูงขึ้น`,
        return: `~0`
    },
    {
        name: `อื่นๆ`,
        desc: `สินทรัพย์อื่นที่มีสภาพคล่อง เช่น ทองคำ<br>
(ไม่รวมที่ดินอสังหาริมทรัพย์ เพราะไม่สามารถแปลงเป็นเงินสดได้ทันที)
`,
        return: `~6.0`
    },
    {
        name: `กองทุนอสังหาริมทรัพย์/กอง REIT และกองทุนโครงสร้างพื้นฐาน`,
        desc: `กองทุนที่ระดมทุนจากผู้ลงทุนไปลงทุนในอสังหาริมทรัพย์ประเภทใด ประเภทหนึ่ง ขึ้นอยู่กับนโยบายการจัดตั้งกองทุนขึ้นมา  เช่น โรงแรม เซอร์วิสอพาร์ทเมนท์ อาคารสำนักงาน โรงงานคลังสินค้า ศูนย์การค้า สนามบิน เป็นต้น <br>
โดยหลักๆ กองทุนอสังหาริมทรัพย์แบ่งได้เป็น 3 ประเภท ได้แก่ <br>
1.กองทุนที่ซื้ออสังหาริมทรัพย์นั้นมาเป็นกรรมสิทธิ์ หรือ Freehold  <br>
2.กองทุนที่ลงทุนในสิทธิการเช่าของอสังหาริมทรัพย์ หรือ Leasehold <br>
3.กองทุนผสม คือ กองทุนที่ผสมไปด้วยอสังหาริมทรัพย์แบบ Freehold และ Leasehold <br><br>
กองทุน REIT (Real Estate Investment Trust) นั้นมีหลักการคล้ายกับ กองทุนรวมอสังหาริมทรัพย์ แต่จะแตกต่างกันในเรื่องของกฏเกณฑ์และข้อกำหนดต่างๆ
`,
        return: `~7.5`
    },
    {
        name: `สัดส่วนของแต่ละสินทรัพย์`,
        desc: `เช่น แผนการลงทุนในตราสารหนี้ 100% แผนการลงทุนแบบผสม ตราสารหนี้ 50% ตราสารทุน 50% เป็นต้น`
    },
    {
        name: `เงินใช้จ่ายหลังเกษียณ`,
        desc: `คำนวณเงินถึงสิ้นอายุขัย โดยประเมินจากอัตราการตายตามตารางมรณะที่ประกาศโดย คปภ.`
    },
    {
        name: `เงินเดือน`,
        desc: `โปรแกรมคำนวณนี้ใช้ประมาณการเงินเดือนขึ้น 4 %`
    },
];


let assetsService = {
    getAssetsInfo(type) {
        let result = _.findWhere(dict, {name: type});
        return result ? result : false;
    }
};

export {assetsService}
